import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetSuggestedMembersQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SuggestedMemberFilter>;
  orderBy?: Types.InputMaybe<Array<Types.SuggestedMemberOrder>>;
  page: Types.PageInput;
  resourceId: Types.Scalars['ID']['input'];
}>;


export type GetSuggestedMembersQuery = { __typename?: 'Query', suggestedMembers?: { __typename?: 'SuggestedMemberConnection', totalCount: number, nodes: Array<{ __typename?: 'SuggestedAccountUser', avatarColor?: Types.AvatarColor | null, canView?: boolean | null, email?: string | null, inviteEmailAddress?: string | null, isPending: boolean, licenseType?: Types.AccountUserLicenseTypeValue | null, id: string, name?: string | null, profileImage?: { __typename?: 'Images', image64?: string | null } | null } | { __typename?: 'SuggestedAccountUserGroup', emoji?: string | null, memberCount?: number | null, id: string, name?: string | null } | { __typename?: 'SuggestedShareList', memberCount?: number | null, id: string, name?: string | null, avatarIcons?: Array<{ __typename?: 'UserInfo', id: string, name?: string | null, profileImageUrl?: string | null } | null> | null, creator?: { __typename?: 'UserInfo', id: string, name?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };


export const GetSuggestedMembers = /*#__PURE__*/ gql`
    query GetSuggestedMembers($filter: SuggestedMemberFilter, $orderBy: [SuggestedMemberOrder!], $page: PageInput!, $resourceId: ID!) {
  suggestedMembers(
    filter: $filter
    orderBy: $orderBy
    page: $page
    resourceId: $resourceId
  ) {
    nodes {
      id
      name
      ... on SuggestedAccountUser {
        avatarColor
        canView
        email
        inviteEmailAddress
        isPending
        licenseType
        profileImage {
          image64
        }
      }
      ... on SuggestedAccountUserGroup {
        emoji
        memberCount
      }
      ... on SuggestedShareList {
        memberCount
        avatarIcons {
          id
          name
          profileImageUrl
        }
        creator {
          id
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ` as unknown as DocumentNode<GetSuggestedMembersQuery, GetSuggestedMembersQueryVariables>;

          

          export const useGetSuggestedMembersQuery = (options?:QueryHookOptions<GetSuggestedMembersQuery, GetSuggestedMembersQueryVariables>) => useQuery(GetSuggestedMembers, options);

          

          export type GetSuggestedMembersQueryOptions = QueryHookOptions<GetSuggestedMembersQuery, GetSuggestedMembersQueryVariables>;

          

          export const useGetSuggestedMembersLazyQuery = (options?:LazyQueryHookOptions<GetSuggestedMembersQuery, GetSuggestedMembersQueryVariables>) => useLazyQuery(GetSuggestedMembers, options);

          

          export type GetSuggestedMembersQueryResult = ReturnType<typeof useGetSuggestedMembersQuery>;

          
